import { type Color } from '@mui/material'

// reason: these are the color tokens so they are hardcoded
/* eslint-disable @dhl/mui/no-hardcoded-colors */
export const postYellow = {
  100: '#FFFAE5',
  200: '#FFF5CC',
  300: '#FFEB99',
  400: '#FFE066',
  500: '#FFD633',
  600: '#FFCC00',
  700: '#CCA300',
  800: '#997A00',
  900: '#665200',
} satisfies Partial<Color>
